import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import EventLogApi from '../../api/eventlog';
import { PERMISSIONS_MUTATIONS_NAME } from './name';
import { TPermissionsStoreState } from './types';

export async function getPermissions(context: ActionContext<TPermissionsStoreState, unknown>) {
  const response = await EventLogApi.getPermissions();
  context.commit(getLocalState(PERMISSIONS_MUTATIONS_NAME.setPermissions), response);
}
